<div class="row">
  <div class="column small-12 small-12 large-12">
    <div class="row">
      <div class="column small-12 small-3 large-3">
        <img [src]="appCfg.conf.ui.logoImage" class="index-logo" [ngClass]="{'bigger': !club.obId}">
      </div>
      <div class="column small-12 small-9 large-9">
      </div>
    </div>
    <div class="row" *ngIf="club.obId; else card_only;">
      <div style="position: relative;" class="column small-1 small-1 large-1 hide-for-small-only hide-for-small-only">
        <div style="top: 80px;" class="orange-circle">1</div>
        <hr class="orange-vertical-line"/>
        <div style="top: 150px;" class="orange-circle">2</div>
      </div>
      <div class="column small-12 small-11 large-4 form-padding" >
        <div class="auth-container">
          <form class="index-form">
            <div class="index-form-label">{{ 'I_CHOOSE_MY_CENTER' | translate }}</div>
            <div>
              <div class="index-form-input ob-club-picker"
                   [routerLink]="['/choose-centre']">
                {{(club.obId ? club.obId + '// ' : '') + club.company}}
              </div>
              <div class="reset-selection" *ngIf="club.obId !== defaultClub.obId">
                <a class="reset-btn" (click)="resetSelection()">
                  <img src="./assets/img/icon-location.svg" width="12">
                  {{'RETURN_TO_CENTER_X' | translate | sprintf:defaultClub.company }}
                </a>
              </div>
            </div>
            <div>
              <label for="password" class="index-form-label">{{ 'I_ENTER_MY_CUSTOMER_CODE' | translate }}</label>
              <div style="position: relative">
                <input type="text" class="index-form-input" name="code"
                       id="password" [(ngModel)]="userId" disabled>
                <button class="undo-btn" type="button" (click)="undo()">
                  <img src="./assets/img/arrow-left.svg">
                </button>
              </div>
            </div>
          </form>
          <div class="keypad-container" *ngIf="club.obId">
            <ul class="keypad-ul">
              <li>
                <a class="keypad-a" (click)="pressKey('7')">
                <span class="keypad-number">
                  7
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('8')">
                <span class="keypad-number">
                  8
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('9')">
                <span class="keypad-number">
                  9
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('4')">
                <span class="keypad-number">
                  4
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('5')">
                <span class="keypad-number">
                  5
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('6')">
                <span class="keypad-number">
                  6
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('1')">
                <span class="keypad-number">
                  1
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('2')">
                <span class="keypad-number">
                  2
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('3')">
                <span class="keypad-number">
                  3
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('clear')" style="background:linear-gradient(#FB9C9C,#E05656)">
                <span class="keypad-number">
                  <img src="./assets/img/times-circle-black.svg" width="24">
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('0')">
                <span class="keypad-number">
                  0
                </span>
                </a>
              </li>
              <li>
                <a class="keypad-a" (click)="pressKey('check')" style="background:linear-gradient(#B5E79F,#5AAF35)">
                <span class="keypad-number">
                  <img src="./assets/img/check-circle.svg">
                </span>
                </a>
              </li>
            </ul>
          </div>
          <div (click)="stationInfoVisible = !stationInfoVisible"
               style="min-height: 50px;">
            <div *ngIf="stationInfoVisible" style="font-size: 10px;">
              IP {{station.ip}} . Host: {{station.hostname}} <br/>
              WS: {{station.version}} . <br/> DB {{station.dbVersion}} . UI: {{station.uiVersion}}
            </div>
          </div>
        </div>
      </div>
      <div style="position: relative;"
           class="column small-6 small-6 large-6">
      </div>
    </div>
    <ng-template #card_only>
      <div class="column small-12 form-padding">
        <div class="badge-signup">
          <div class="icon"></div>
          <div class="name">{{'CONNECT_BY_CARD' | translate }}</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<app-footer></app-footer>
